import styled from 'styled-components';

export const AnchorTitle = styled.span`
  &:before {
    display: block;
    content: ' ';
    margin-top: -35px;
    height: 35px;
    visibility: hidden;
    pointer-events: none;
  }
`;
